import React, { createContext, useContext } from 'react';

const Context = createContext();

export const useAttachment = () => useContext(Context);

export const AttachmentProvider = ({ attachment, children }) => {
  return <Context.Provider value={attachment}>{children}</Context.Provider>;
};
